import { formatRon, parseRonCents, validatePriceReduction } from "./priceReduction";

const text = (value) => String(value ?? "").trim();
const hasText = (value) => Boolean(text(value));
export const LP015_TEMPLATE_ID = "104126000000393245";

export const getOnlineAdditionalActReadiness = ({ data, newPrice, loading = false, error = "" } = {}) => {
  const hasData = !loading && !error && data?.ok === true;
  const checks = data?.readiness || {};
  const ciAddress = checks.ciAddress || {};
  const seller = data?.seller || {};
  const validation = validatePriceReduction(data?.currentPrice, newPrice);
  const unavailableMessage = loading
    ? "Se verifică datele produsului…"
    : error
      ? "Datele nu au putut fi verificate. Reîncearcă încărcarea."
      : "Datele produsului nu sunt încă disponibile.";
  const vendorUnavailableMessage = checks.message || "Datele CI nu au putut fi verificate în Informații furnizor.";

  const requirement = (id, label, isComplete, value, missingMessage) => ({
    id,
    label,
    isComplete: Boolean(hasData && isComplete),
    value: hasData && isComplete ? text(value) : "",
    missingMessage: hasData ? missingMessage : unavailableMessage,
  });
  const vendorRequirement = (id, label, presence, missingMessage) => requirement(
    id,
    label,
    presence === true,
    "Disponibil în Informații furnizor.",
    presence === false ? missingMessage : vendorUnavailableMessage,
  );
  const addressMissing = (part) => ciAddress.present === false
    ? "Lipsește adresa cu categoria CI din Informații furnizor."
    : `Lipsește ${part} din adresa CI.`;
  const contractDate = text(data?.dataContract);
  const formattedContractDate = /^\d{4}-\d{2}-\d{2}$/.test(contractDate)
    ? contractDate.split("-").reverse().join(".")
    : contractDate;
  const isOnline = text(data?.status).replace(/^\d+[_\s-]+/, "").toUpperCase() === "ONLINE";

  const requirements = [
    requirement("online-status", "Produs Online", isOnline && data?.eligibility?.eligible === true, data?.status,
      data?.eligibility?.reason || "Produsul nu mai are statusul Online."),
    requirement("sku", "SKU produs", hasText(data?.sku), data?.sku, "Lipsește SKU-ul produsului."),
    requirement("contract-number", "Număr contract", hasText(data?.nrContract), data?.nrContract,
      "Lipsește numărul contractului din Jira."),
    requirement("contract-type", "Tip contract (LP001–LP006)", /\bLP00[1-6]\b/i.test(text(data?.contractType)), data?.contractType,
      hasText(data?.contractType) ? "Tipul de contract nu este compatibil cu LP015." : "Lipsește tipul contractului din Jira."),
    requirement("contract-date", "Data contractului", checks.contractDate === true && hasText(contractDate), formattedContractDate,
      "Data contractului lipsește sau nu a putut fi verificată în Jira."),
    requirement("seller-name", "Nume și prenume vânzător", text(seller.name).split(/\s+/).filter(Boolean).length >= 2, seller.name,
      "Completează numele și prenumele vânzătorului în Jira."),
    requirement("seller-phone", "Telefon vânzător", hasText(seller.phone), seller.phone, "Lipsește telefonul vânzătorului."),
    requirement("seller-email", "Email vânzător", /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(text(seller.email)), seller.email,
      hasText(seller.email) ? "Emailul vânzătorului nu este valid." : "Lipsește emailul vânzătorului."),
    requirement("brand", "Brand", hasText(data?.brand), data?.brand, "Lipsește brandul produsului din Jira."),
    requirement("model", "Model", hasText(data?.model), data?.model, "Lipsește modelul produsului din Jira."),
    requirement("current-price", "Suma actuală", parseRonCents(data?.currentPrice) > 0, formatRon(data?.currentPrice),
      "Suma actuală nu este disponibilă. Reîncarcă datele produsului."),
    requirement("new-price", "Noua sumă agreată telefonic", validation.isValid, formatRon(newPrice), validation.message),
    requirement("price-decrease", "Diminuarea prețului", validation.isValid, formatRon(validation.difference),
      "Introdu o sumă nouă validă, mai mică decât suma actuală, pentru calcularea diferenței."),
    vendorRequirement("id-series", "Serie CI", checks.serieCI, "Lipsește seria CI din Informații furnizor."),
    vendorRequirement("id-number", "Număr CI", checks.nrCI, "Lipsește numărul CI din Informații furnizor."),
    vendorRequirement("ci-street", "Adresă CI – stradă", ciAddress.street, addressMissing("strada")),
    vendorRequirement("ci-city", "Localitate (CI)", ciAddress.city, addressMissing("localitatea")),
    vendorRequirement("ci-state", "Județ (CI)", ciAddress.state, addressMissing("județul")),
    vendorRequirement("ci-postal-code", "Cod poștal (CI)", ciAddress.postalCode, addressMissing("codul poștal")),
    vendorRequirement("ci-country", "Țară (CI)", ciAddress.country, addressMissing("țara")),
    requirement("lp015-template", "Șablon Zoho LP015",
      data?.lp015Ready === true && text(data?.lp015TemplateId) === LP015_TEMPLATE_ID,
      "LP015 · Zoho Sign", "Șablonul Zoho LP015 nu a putut fi verificat. Actualizează datele produsului."),
  ];
  const completedCount = requirements.filter((item) => item.isComplete).length;
  return {
    requirements,
    completedCount,
    missingCount: requirements.length - completedCount,
    totalCount: requirements.length,
    isReady: completedCount === requirements.length,
  };
};
